import { Component } from '@angular/core';
import { PlanTypeDTO } from 'src/app/models/Plans/PlanTypeDTO';
import { PlanFrequencyDTO } from 'src/app/models/Plans/PlanFrequencyDTO';
import { PlanService } from 'src/app/services/plan.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ResponseBase } from 'src/app/models/ResponseBase';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-plan-type-form',
    templateUrl: './plan-type-form.component.html',
    styleUrl: './plan-type-form.component.css',
    imports: [CommonModule, FormsModule, RouterModule]
})
export class PlanTypeFormComponent {

  title = 'Create Plan Type';
  planType: PlanTypeDTO = {} as PlanTypeDTO;
  frequencies: PlanFrequencyDTO[] = [];

  /**
   *
   */
  constructor(private planService: PlanService, private route: ActivatedRoute, private alertService: AlertService) {


  }
  ngOnInit(): void {

    this.route.params.subscribe(params => {
      //this.id = params['id']; // Access the 'id' parameter from the URL
      const idParam = params['id'];
      this.planType.planTypeId = idParam !== null ? Number(idParam) : undefined;
    });


    

    if (this.planType.planTypeId) {
      this.title = 'Edit Plan Type';
      this.planService.GetPlanTypeById(this.planType.planTypeId).subscribe((data: PlanTypeDTO) => {
        this.planType = data;
      });

    }

    this.planService.GetPlanFrequencies().subscribe((data: PlanFrequencyDTO[]) => {
      this.frequencies = data;
    });
  }

  savePlanType(): void {
    // Logic to save the plan type

    if (this.planType.planTypeId) {
      // Update existing plan type
      this.planService.UpdatePlanType(this.planType).subscribe((response: ResponseBase) => {

        if (!response.hasValidationErrors) {
          this.alertService.success('Plan Type updated successfully');
          setTimeout(() => {
            window.history.back();
          }, 1000);
        } else {
          this.alertService.error(response.validationErrorMessage);
        }
      });
    } else {
      // Create new plan type
      this.planService.CreatePlanType(this.planType).subscribe((response: ResponseBase) => {
        if (!response.hasValidationErrors) {
          this.alertService.success('Plan Type created successfully');
          setTimeout(() => {
            window.history.back();
          }, 1000);
        } else {
          this.alertService.error(response.validationErrorMessage);
        }
      });
    }
  }
}
